import { FC, useState, ChangeEvent } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { useStyles } from './styles';
import TabPanel from 'components/TabPanel';
import OIDC from './OIDC';
import SAML from './SAML';

const SSO: FC = () => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState('one');
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const handleTabChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        className={classes.tabs}
        TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
        variant='standard'
      >
        <Tab value='one' label='OIDC' {...a11yProps('one')} className={classes.label} />
        <Tab value='two' label='SAML' {...a11yProps('two')} className={classes.label} />
      </Tabs>
      <div className={classes.tabBox}>
        <TabPanel value={activeTab} index='one'>
          <OIDC />
        </TabPanel>

        <TabPanel value={activeTab} index='two'>
          <SAML />
        </TabPanel>
      </div>
    </>
  );
};

export default SSO;
